

import {Component, Mixins, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import EtkinlikForm from "@/components/forms/EtkinlikForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {EtkinlikEntity} from "@/entity/EtkinlikEntity";
import {VCalendar} from "@/types";
import {KisiEntity} from "@/entity/KisiEntity";
import {EtkinlikKaynagi, etkinlikKaynagiCoz, takipKartiYolu} from "@/helpers/AjandaGecisHelper";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";

@Component({
  components: {DeleteDialog, EtkinlikForm, FormDialog}
})
export default class AjandaInfo extends Mixins(ObjectInputMixin) {

  searchText = ''
  takvimTipi = "month";
  focus:Date|string= '';
  today = '';
  title = '';
  takvimTipLabel = {
    month: 'Aylık',
    week: 'Haftalık',
    day: 'Günlük',
    '4day': '4 Günlük',
  }
  selectedEvent: EtkinlikEntity = {} as EtkinlikEntity;
  selectedElement: EventTarget | null = null;
  selectedOpen = false;
  previousCalendarType = "month"; // Önceki takvim tipini saklamak için

  start: Start | null = null;
  end: End | null = null;
  events: Event[] = [];

  etkinlikler:Array<EtkinlikEntity> = [];
  takipKartiAraniyor = false;

  // DEV-2788: Seçili etkinlik bir takibe bağlı mı (nottan ya da işten aktarılmış mı)?
  get etkinlikKaynagi(): EtkinlikKaynagi | null {
    return etkinlikKaynagiCoz(this.selectedEvent && this.selectedEvent.details);
  }

  // DEV-2788: Nottan aktarılan etkinlikte gizli kart izi takibi doğrudan verir.
  // İzi olmayan eski kayıtlarda ve işlerde takip, aktarılan notun/işin
  // kendisinden okunur. Okuma butona basılınca yapılır: popup her açıldığında
  // istek atılmaz, kaynağı silinmiş etkinlik de yalnız butona basana söylenir.
  async takipKartinaGit() {
    const kaynak = this.etkinlikKaynagi;
    if (!kaynak || this.takipKartiAraniyor) {
      return;
    }
    if (kaynak.tur === 'takip') {
      this.selectedOpen = false;
      this.$router.push(takipKartiYolu(kaynak.id));
      return;
    }
    const etkinlikId = this.selectedEvent.id;
    const kayitAdi = kaynak.tur === 'not' ? 'not' : 'iş';
    this.takipKartiAraniyor = true;
    // Silinmiş kaynağın 404'ü genel "bulunamadı" uyarısı yerine aşağıda
    // ne olduğunu söyleyen bir mesajla karşılanır.
    StatusCodeHelper.dontShow404Alert = true;
    try {
      const response: any = await this.$http.get('/api/v1/' + kaynak.tur + '/' + kaynak.id);
      // Yanıt gelene kadar kullanıcı popup'ı kapattıysa ya da başka bir
      // etkinliğe geçtiyse onu habersizce başka sayfaya götürme.
      if (!this.selectedOpen || this.selectedEvent.id !== etkinlikId) {
        return;
      }
      const yol = takipKartiYolu(response?.data?.takip_id, response?.data?.takip_durumu);
      if (!yol) {
        this.$toast.warning('Etkinliğin aktarıldığı ' + kayitAdi + ' bir takibe bağlı değil.');
        return;
      }
      this.selectedOpen = false;
      this.$router.push(yol);
    } catch (error) {
      if (error?.response?.status === 404) {
        this.$toast.warning('Etkinliğin aktarıldığı ' + kayitAdi + ' bulunamadı, silinmiş olabilir.');
      }
    } finally {
      StatusCodeHelper.dontShow404Alert = false;
      this.takipKartiAraniyor = false;
    }
  }


  @Watch('searchText')
  onSearchTextChange(newVal: string, oldVal: string) {

    if (!newVal && oldVal) {

      this.takvimTipi = this.previousCalendarType || 'month';
      this.selectedEvent = {} as EtkinlikEntity;
    }
  }


  @Watch('takvimTipi')
  onTakvimTipiChange(newVal: string) {

    if (newVal !== 'day' || !this.searchText) {
      this.previousCalendarType = newVal;
    }
  }

  setSelectEvent(event:EtkinlikEntity){
    if (event && event.start_date) {
      this.takvimTipi = 'day';
      this.focus = event.start_date;
    }
  }


  onSearchClear() {
    this.selectedEvent = {} as EtkinlikEntity;
    this.takvimTipi = this.previousCalendarType || 'month';
    this.searchText = '';
  }

  mounted() {
    this.today = new Date().toISOString();
    this.$nextTick(() => {
      if (this.$refs.calendar) {
        (this.$refs.calendar as VCalendar).checkChange();
      }
    });
    this.load();
  }

  showEvent({ nativeEvent, event }: { nativeEvent: MouseEvent, event: EtkinlikEntity }) {
    const open = () => {
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true));
    }
    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }
    nativeEvent.stopPropagation();
  }

  updateRange({start, end}: { start: Start; end: End }) {
    this.start = start;
    this.end = end;
    this.title = new Date(start.date).toLocaleString("tr-TR", {month: 'long'}) + " " + start.year;
  }

  viewDay({date}: { date: string }) {
    this.focus = date;
    this.takvimTipi = 'day';
  }

  setToday() {
    this.focus = this.today;
  }

  prev() {
    if (this.$refs.calendar) {
      (this.$refs.calendar as VCalendar).prev();
    }
  }

  next() {
    if (this.$refs.calendar) {
      (this.$refs.calendar as VCalendar).next();
    }
  }

  load() {
    this.$http.get('/api/v1/personel/' + this.$store.state.user.id + '/etkinlik').then((response) => (this.etkinlikler = response.data));
  }

  deleteEtkinlik(etkinlik: EtkinlikEntity) {
    if (etkinlik.hatirlatici_id)
      this.$http.delete('/api/v1/hatirlatici/' + etkinlik.hatirlatici_id);
    if (etkinlik.on_hatirlatici_id)
      this.$http.delete('/api/v1/hatirlatici/' + etkinlik.on_hatirlatici_id);
    this.load();
  }
}
export type Start = {
  date: string;
  time: string;
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  weekday: number;
  hasDay: boolean;
  hasTime: boolean;
  past: boolean;
  present: boolean;
  future: boolean;
}
export type End = {
  date: string;
  time: string;
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  weekday: number;
  hasDay: boolean;
  hasTime: boolean;
  past: boolean;
  present: boolean;
  future: boolean;
}
export type Event = {
  name: string;
  start: string;
  end: string;
  color: string;
  details: string;
}
